import styled from 'styled-components'

export const CreateReservationContainer = styled.div`
  margin-top: 10px;
`
